const objFunc = () => {
  return {
    loans: [],

    settlementStatus: {
      loanId: '',
      docExp: '',
      docSigned: false,
      paymentMade: false
    },
    showRateChangeModal: false,
    refinanceDenied: false,

    currentTlxeApplicationInProgress: false,
    expressApplicationDeepLink: '',
    currentNlsApplication: {},
    dashboardReapplyInfo: {},
    declinedNlsApplications: [],
    declinedTlxeApplications: [],
    nlsUploadDocEnabled: false,
    showCreditLimitModal: false
  }
}

export default objFunc()

export const defaultObj = objFunc()
